<template>
  <div class="column medium-8 small-12">
    <h3>{{ translations.selectedTopUp }}</h3>
      <div class="small__package" style="background-image: url(/images/paket-bg-n.png);" v-if="type">
        <h2>{{ type.amount }}</h2>
        <div class="small__package-box">
            <p>{{ translations.validity }} {{ type.validDays }} {{ translations.days }}</p>
        </div>
      </div>
      <div class="text-with-icon"><img src="/icons/svg/mobile-purple.svg" alt=""><span>{{ translations.enterPhone1 }}</span></div>
      <div class="error" v-show="error">{{ error }}</div>
      <div class="input">
        <div class="form__item form__item--text">
            <label for="">{{ translations.enterPhone1 }}</label>
            <input type="text" :placeholder="translations.exampleNumber" v-model="msisdn1">
        </div>
      </div>
      <div class="input">
        <div class="form__item form__item--text">
            <label for="">{{ translations.enterPhone2 }}</label>
            <input type="text" :placeholder="translations.exampleNumber" v-model="msisdn2">
        </div>
      </div>
    <a @click="initAuth" class="button" :title="translations.nextStep" :aria-label="translations.nextStep">{{ translations.nextStep }}</a>
  </div>
</template>

<script>
import api from '../apiAccess.js'

export default {
  name: 'EnterNumber',
  props: [ 'translations', 'type' ],
  data () {
    return {
      error: null,
      msisdn1: '',
      msisdn2: ''
    }
  },
  methods: {
    initAuth() {
      if (this.msisdn1 !=  this.msisdn2) {
        this.error = this.translations.errorSame
        return
      }
      let lang = document.documentElement.lang.toLowerCase()
      api.initAuth(this.msisdn1, lang)
      .then(r => {
        if (r && r.status === true) {
          this.$emit('moveToCode', { msisdn: this.msisdn1, node: r.response.node } )
        }
        else if (r && r.status === false) {
          if (r.message === "Invalid IziMobil Number") {
            this.error = this.translations.notIziMsisdn
            this.$emit('error', r.message )
          } else {
            this.error = r.message
            this.$emit('error', r.message )
          }
        }
        else {
          this.error = r
          this.$emit('error', r )
        }
      })
      .catch(e => {
        this.error = this.translations.systemError
        this.$emit('error', e )
        console.error(e)
      })
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/EnterNumber.vue